import { ellipsis, hasClientRing } from "@/common/style/commonStyle";
import {
	makeStyles,
	tokens,
	typographyStyles,
} from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		width: "100%",
		height: "100%",
		overflow: "hidden",
	},
	searchInput: {
		marginTop: 0,
		marginLeft: tokens.spacingHorizontalL,
		border: "none",
		width: "100%",
		flexGrow: 1,
		flexShrink: 1,
		flexBasis: 0,
		minWidth: 0,
	},
	headerTitle: {
		...typographyStyles.body1Stronger,
	},
	listItemHeader: {
		fontWeight: tokens.fontWeightSemibold,
	},
	spinner: {
		margin: tokens.spacingHorizontalM,
	},
	startMedia: {
		backgroundColor: "transparent",
	},
	endMedia: {
		padding: 0,
	},
	noResultText: {
		margin: "1rem auto",
	},
	button: {
		color: tokens.colorNeutralForeground3,
	},
	menuPopoverClasses: {
		padding: "4x",
	},
	operatorTemplatesMenu: {
		maxWidth: "304px",
		...ellipsis(),
	},
	operatorTemplatesMenuItem: {
		width: "100%",
		"& span:nth-of-type(1)": {
			...ellipsis(),
		},
	},
	tabList: {
		margin: "0px 5px",
	},
	tab: {
		padding: "3px 10px",
		border: "1px solid lightgray",
	},
	notes: {
		textAlign: "left",
	},
	searchFilterBar: {
		marginBottom: tokens.spacingHorizontalL,
		marginRight: tokens.spacingHorizontalS,
	},
	hasClientBorder: hasClientRing(),
	noteIcon: {
		marginRight: "6px",
	},
});

export const useMenuItemStyle = makeStyles({
	root: {
		">span:last-child": ellipsis(),
	},
});
